
<template>
    <!-- 体检一体机 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="设备编号">
            <el-input
              v-model.trim="formInline.inputdeviceno"
              placeholder="请输入设备编号"
              clearable
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              plain
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
          <!-- <el-form-item>
            <el-button
              type="warning"
              plain
              class="el-icon-plus"
              @click="dialogFormVisible = true"
              >新增</el-button
            >
          </el-form-item> -->
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
        
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
              </template>
            </el-table-column>
          
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备描述"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            
            <el-table-column label="操作" width="350" align="center">
              <template slot-scope="scope">
                <el-button
                   
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="success"
                  size="mini"
                  plain
                  @click="handDetail(scope.row)"
                  >数据</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
        <!-- 弹出新增 -->
        <el-dialog
          title="新增设备信息"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="dangerbuttonxz"
          @close="closexz"
        >
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item
              label="设备编号"
              :label-width="formLabelWidth"
              prop="xzdate"
            >
              <el-input
                v-model.trim="form.xzdate"
                placeholder="请输入设备编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备名称"
              :label-width="formLabelWidth"
              prop="xzname"
            >
              <el-input
                v-model.trim="form.xzname"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备描述"
              :label-width="formLabelWidth"
              prop="xzsec"
            >
              <el-input
                v-model.trim="form.xzsec"
                type="textarea"
                :rows="3"
                placeholder="请输入设备描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click="cancelxz">取 消</el-button>
            <el-button
              type="primary"
              @click="submitForm('form')"
              :loading="addLoading"
              >确 定</el-button
            >
          </div>
        </el-dialog>
  
        <!-- 弹出修改-->
        <el-dialog
          title="修改设备信息"
          :visible.sync="dialogFormEdit"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="dangerbuttonedit"
        >
          <el-form ref="formedit" :model="formedit" :rules="rules">
            <el-form-item
              label="设备编号"
              :label-width="formLabelWidth"
              prop="editdate"
            >
              <el-input
                disabled
                v-model.trim="formedit.editdate"
                auto-complete="off"
                placeholder="请输入设备编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备名称"
              :label-width="formLabelWidth"
              prop="editname"
            >
              <el-input
                v-model.trim="formedit.editname"
                auto-complete="off"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备描述"
              :label-width="formLabelWidth"
              prop="editsec"
            >
              <el-input
                v-model.trim="formedit.editsec"
                auto-complete="off"
                type="textarea"
                :rows="3"
                placeholder="请输入设备描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click="dialogFormEdit = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitFormEdit('formedit')"
              :loading="editLoading"
              >确 定</el-button
            >
          </div>
        </el-dialog>

      </div>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  export default {
    data() {
      return {
        selectOldmanList: [], //select下拉菜单的老人集合
        addLoading: false,
        editLoading: false,
        currentPage: 1, //初始页
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        deviceno: "",
        list: [], //返回的结果集合
        allList: [], //返回紧急按钮的集合  全部数据
        totalDataNumber: 0, //数据的总数,
        loading: "", //加载数据中
        oldmanNameIdList: [], //老人姓名和Id （用于下拉菜单展示老人以及绑定的时候 删除老人操作）
        oldmanIdNameUnshift: [], //用于解绑时 添加老人操作
        oldIdCard: [], //老人身份证
        oldmanList: [], //老人所有信息列表
        formInline: {
          inputdeviceno: "",
        },
        //绑定位置 ， 自定义 老人和床位
        dialogFormBangdi: false,
        locationShow: true, //绑定床位的input 和 span 显示和隐藏的切换
        oldManShow: false, //选择老人的显示和隐藏
        bedShow: false, //选择床位信息的显示和隐藏
        locationBedShow: "", //如果是绑定类型为床位绑定   就把Cascader级联选择器选择的楼栋 层数 房间 床位  回显放到location绑定的位置
        cascadervalue: [], //Cascader级联选择器集合的值默认为空
        optionsBed: [], //床位号的Cascader级联选择器集合
        bindType: 0, //设备绑定的类型
        // 新增表单dialog
        dialogFormVisible: false,
        dialogVisible: false,
        form: {
          xzdate: "",
          xzsec: "",
          xzname: "",
        },
        formLabelWidth: "120px",
        //修改表单dialog
        dialogFormEdit: false,
        formedit: {
          editdate: "",
          editname: "",
          editsec: "",
          // editaddress:'',
        },
        rules: {
          // 新增正则验证匹配规则
          xzdate: [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
          ],
          xzsec: [
            { min: 1, max: 100, message: "长度在 1到 100 个字符" },
          ],
          xzname: [
            { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          ],
          editdate: [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
          ],
          editsec: [
            { min: 1, max: 100, message: "长度在 1到 100 个字符" },
          ],
          editname: [
            { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          ],
        },
        fileFlag: false,
      };
    },
    methods: {
      //选中行
      handleSelectionChange(val) {
        console.log("val:", val);
      },
      //点击查询
      onSubmit() {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      },
  
      //键盘事件 按下键盘回车 查询
      enterSearchMember(e) {
        console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13 && this.formInline.inputdeviceno != null) {
          if (this.formInline.inputdeviceno == "") {
            this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
          } else {
            this.getTableData(
              this.formInline.inputdeviceno,
              (this.pageNum = 1),
              (this.pageSize = 10)
            );
          }
        }
      },
  
      // 修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      // 修改table header的背景色
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      // 点击弹出修改信息的弹窗
      handleEdit(index, row) {
        (this.dialogFormEdit = true), //打开修改弹窗
          console.log(index, row);
        this.listIndex = index; //记录索引
        console.log(this.listIndex);
        //this.formedit=row;//记录数据
        this.formedit = Object.assign({}, row); //深拷贝记录
        console.log(this.formedit.id);
        //将对应行所对的表格值赋给input框
        this.$set(this.formedit, "editdate", row.deviceNo);
        this.$set(this.formedit, "editsec", row.remark);
        this.$set(this.formedit, "editname", row.deviceName);
        console.log(this.formedit.editdate);
      },
      //详情页面
      handDetail(row) {
        bus.$emit("homePage", {
              type: "jump",
              path: "/BloodPressData",
              title: '测量数据',
              params: {
                deviceNo:row.deviceNo
              }
        });
  
      },
      //点击修改弹窗的 确定按钮提交修改的数据
      submitFormEdit(datainfo) {
        //正则匹配规则rules
        this.$refs[datainfo].validate((valid) => {
          //判断数据是否存在
          if (valid) {
            let param = {
              id: this.formedit.id,
              remark: this.formedit.editsec,
              deviceName: this.formedit.editname,
              deviceNo: this.formedit.editdate,
            };
            console.log(param);
            this.editLoading = true;
            this.$postJson("dmc/commonDevice/edit", param)
              .then((res) => {
                console.log(res);
                this.editLoading = false;
                this.dialogFormEdit = false; //关闭修改弹窗
                if (res.code == "200") {
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "success",
                    });
                    this.getTableData();
                  }, 300);
                  console.log("修改成功!");
                } else {
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "error",
                    });
                  }, 300);
                }
              })
              .catch((res) => {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              });
          } else {
            console.log("修改失败!");
            return false;
          }
        });
      },
  
      //删除
      handleDelete(index, row) {
        if (row.bind == false) {
          this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            closeOnClickModal: false,
          })
            .then(() => {
              console.log(index, row);
              let id = row.id;
              console.log(id);
              this.$postJson("dmc/commonDevice/deleteById/"+id).then((res) => {
                if (res.code == 200) {
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                  this.getTableData();
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        } else {
          this.$message({
            type: "error",
            message: "该设备已经被绑定，请先解绑后再进行删除!",
          });
        }
      },
      //关闭新增的dialog
      closexz() {
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
      },
      //点击新增取消  重置表单以及验证
      cancelxz() {
        this.dialogFormVisible = false;
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
      },
      // 新增弹出框点击确定提交信息
      submitForm(datainfo) {
        this.$refs[datainfo].validate((valid) => {
          if (valid) {
            let param = {
              remark: this.form.xzsec,
              deviceName: this.form.xzname,
              deviceNo: this.form.xzdate,
              deviceType:36
            };
            console.log(param);
            this.addLoading = true;
            this.$postJson(
              "dmc/commonDevice/add",
              param
            ).then((res) => {
              //旧：dmc/button/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                  this.getTableData();
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
            });
          } else {
            console.log("提交失败!");
            return false;
          }
        });
      },
  
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          deviceNo: this.formInline.inputdeviceno,
          deviceType: 36,//一体机
        };
        console.log(param);
        this.loading = true;
        this.$postJson("dmc/commonDevice/queryDeviceListWithPage", param).then(
          (res) => {
            console.log(res);
            //判断是否有数据
            if (res.result.list.length != 0) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.list = res.result.list;
              res.result.list.forEach((item, index) => {
                if (item.location == null){
                  this.$set(item, "status", true);
                }else if (item.location!='' || item.oldmanName!='' ) {
                  this.$set(item, "status", false); //已绑定
                }else {
                  this.$set(item, "status", true);
                }
              });
              setTimeout(() => {
                this.loading = false;
              }, 200);
            } else {
              this.list = [];
              this.totalDataNumber = 0;
              setTimeout(() => {
                this.loading = false;
              }, 1000);
            }
          }
        );
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        //改变每页显示的条数
        this.PageSize = val;
        this.getTableData();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val;
        this.getTableData();
      },
    },
    watch: {
      currentPage(oldV, newV) {
        console.log(oldV, newV);
      },
    },
    created() {
      this.getTableData();
    },
    mounted() {
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  // 修改element-ui默认的样式
  .del {
    color: red !important;
  }
  .fangqu {
    color: green !important;
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  //  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
  //新增的dialog
  @media screen and (min-width: 1200px) {
    ::v-deep .dangerbuttonxz .el-dialog {
      width: 30% !important;
    }
  }
  //修改的dialog
  @media screen and (min-width: 1200px) {
    ::v-deep .dangerbuttonedit .el-dialog {
      width: 30% !important;
    }
  }
  //绑定紧急按钮位置和房间的dialog
  @media screen and (min-width: 1200px) {
    ::v-deep .bangdilocation .el-dialog {
      width: 30% !important;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 1199px) {
    ::v-deep .bangdilocation .el-dialog {
      width: 55% !important;
    }
  }
  </style>